import React, { useEffect, useState, useRef, Component } from 'react';
import './index.css';
import { Twitter, Linkedin, ChevronDown, ArrowUpDown, FileText, Star, BookOpenIcon, PlayCircleIcon, NewspaperIcon, ExternalLinkIcon } from 'lucide-react';
export function App() {
  const [showAll, setShowAll] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string>('All Categories');
  const [selectedTag, setSelectedTag] = useState<string>('All Tags');
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [tagOpen, setTagOpen] = useState(false);
  const categoryRef = useRef<HTMLDivElement>(null);
  const tagRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (categoryRef.current && !categoryRef.current.contains(e.target as Node)) setCategoryOpen(false);
      if (tagRef.current && !tagRef.current.contains(e.target as Node)) setTagOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const allContent = [{
    name: 'Mindset',
    author: 'Dr Carol Dweck',
    category: 'Self-Development',
    tag: 'Book',
    href: ''
  }, {
    name: 'Escaping the Build Trap',
    author: 'Melissa Perry',
    category: 'Product',
    tag: 'Book',
    href: ''
  }, {
    name: 'Relentless',
    author: 'Tim S. Grover & Shari Wenk',
    category: 'Self-Development',
    tag: 'Book',
    href: ''
  }, {
    name: 'Inspired',
    author: 'Marty Cagan',
    category: 'Product',
    tag: 'Book',
    href: ''
  }, {
    name: 'The Slight Edge',
    author: 'Jeff Olson',
    category: 'Self-Development',
    tag: 'Book',
    href: ''
  }, {
    name: 'Super Fans',
    author: 'Pat Flynn',
    category: 'Business',
    tag: 'Book',
    href: ''
  }, {
    name: 'Rise',
    author: 'Siya Kolisi',
    category: 'Biography',
    tag: 'Book',
    href: 'https://www.amazon.co.uk/Rise-Brand-Autobiography-Siya-Kolisi/dp/0008431337'
  }, {
    name: 'Shoe Dog',
    author: 'Phil Knight',
    category: 'Biography',
    tag: 'Book',
    href: 'https://www.amazon.co.uk/s?k=shoe+dog&i=stripbooks&crid=27AJEM79H9K0A&sprefix=shoe+dog%2Cstripbooks%2C219&ref=nb_sb_ss_mvt-t11-ranker_1_8'
  }, {
    name: 'Open',
    author: 'Andre Agassi',
    category: 'Biography',
    tag: 'Book',
    href: ''
  }, {
    name: 'Sprint',
    author: '',
    category: 'Product',
    tag: 'Book',
    href: ''
  }, {
    name: 'In the Plex: How Google Thinks, Works, and Shapes Our Lives',
    author: '',
    category: 'Business',
    tag: 'Book',
    href: ''
  }, {
    name: 'Elon Musk',
    author: 'Walter Isaacson',
    category: 'Biography',
    tag: 'Book',
    href: ''
  }, {
    name: "The non-technical PM's guide to building with Cursor",
    author: "Lenny's Newsletter",
    category: 'Product',
    tag: 'Article',
    href: 'https://www.lennysnewsletter.com/p/the-non-technical-pms-guide-to-building-with-cursor'
  }, {
    name: 'Jason Fried: Build for Yourself, Keep Costs Low and Stay Small',
    author: '',
    category: 'Business',
    tag: 'Youtube',
    href: 'https://www.youtube.com/watch?v=BdDCtMA1gSw'
  }, {
    name: "Marc Andreessen: The Real AI Boom hasn't even started yet",
    author: '',
    category: 'Tech & AI',
    tag: 'Youtube',
    href: 'https://www.youtube.com/watch?v=87Pm0SGTtN8'
  }, {
    name: 'The Rise of Design Engineering - Raphael Salaja - MIT Startup Week',
    author: '',
    category: 'Tech & AI',
    tag: 'Youtube',
    href: 'https://www.youtube.com/watch?v=uEMEs499fUs'
  }, {
    name: 'Head of Claude Code: What happens after coding is solved - Boris Cherny',
    author: '',
    category: 'Tech & AI',
    tag: 'Youtube',
    href: 'https://www.youtube.com/watch?v=We7BZVKbCVw'
  }, {
    name: 'The nature of product - Marty Cagan, Silicon Valley Product Group',
    author: '',
    category: 'Product',
    tag: 'Youtube',
    href: 'https://www.youtube.com/watch?v=h-KVGHoQ_98'
  }, {
    name: 'Steve Jobs - The Lost Interview',
    author: '',
    category: 'Biography',
    tag: 'Youtube',
    href: ''
  }, {
    name: 'Palo Alto Networks CEO Nikesh Arora on the Virtues of Being an Outsider',
    author: '',
    category: 'Business',
    tag: 'Youtube',
    href: 'https://www.youtube.com/watch?v=yco9JP0PyLM&t=4s'
  }, {
    name: 'AI is Eating Logistics - Y Combinator',
    author: '',
    category: 'Tech & AI',
    tag: 'Youtube',
    href: 'https://www.youtube.com/watch?v=KTmxaMdUbHA'
  }];
  const categories = ['All Categories', ...Array.from(new Set(allContent.map(i => i.category)))];
  const tags = ['All Tags', ...Array.from(new Set(allContent.map(i => i.tag)))];
  const filteredContent = allContent.filter(item => {
    const catMatch = selectedCategory === 'All Categories' || item.category === selectedCategory;
    const tagMatch = selectedTag === 'All Tags' || item.tag === selectedTag;
    return catMatch && tagMatch;
  });
  const INITIAL_COUNT = 5;
  const visibleContent = showAll ? filteredContent : filteredContent.slice(0, INITIAL_COUNT);
  const hiddenCount = filteredContent.length - INITIAL_COUNT;
  return <main className="min-h-screen bg-stone-50 font-sans w-full text-gray-900 text-base leading-6" data-id="element-0">
      <div className="max-w-[896px] mx-auto px-4 sm:px-6 py-8 sm:py-12" data-id="element-1">
        {/* Hero Section */}
        <section className="animate-fade-in-up" data-id="element-2">
          <div data-id="element-3">
            <h1 className="text-3xl sm:text-4xl font-medium flex items-center gap-3 leading-9 sm:leading-10 tracking-tight text-gray-900" data-id="element-4">
              Hey 👋 I'm Gordon
            </h1>
          </div>

          {/* CTA Box */}

          {/* About Section */}
          <div className="mt-8 sm:mt-10 text-lg sm:text-xl leading-7 font-normal text-gray-600" data-id="element-5">
            <div className="flex gap-16 items-start" data-id="element-6">
              <div className="flex-1" data-id="element-7">
                <div className="flex flex-wrap items-center gap-2" data-id="element-8">
                  <span data-id="element-9">Currently Senior Product Manager at</span>
                  <a href="https://www.kallidus.com/" target="_blank" rel="noopener noreferrer" className="relative cursor-pointer transition-all duration-300 shadow-[0_4px_12px_-2px_rgba(31,36,46,0.15)] flex h-12 w-12 items-center justify-center rounded-xl hover:scale-110 group" data-id="element-10">
                    <div className="flex h-12 w-12 items-center justify-center overflow-hidden bg-white shadow-sm border border-stone-200/20 rounded-xl" data-id="element-11">
                      <img src="https://cdn.magicpatterns.com/uploads/eJJfsPX6yY3V6ULGbGFTS6/svgviewer-output_(1).svg" alt="Kallidus" className="h-6 w-6 object-contain" data-id="element-12" />
                    </div>
                    <span className="pointer-events-none absolute -top-12 left-1/2 -translate-x-1/2 z-50 whitespace-nowrap bg-stone-50 text-[10px] font-semibold tracking-wide text-gray-900 opacity-0 shadow-sm transition-all duration-300 border border-stone-200 rounded-[10px] px-2.5 py-1 group-hover:opacity-100 group-hover:-translate-y-2" data-id="element-13">
                      Kallidus
                    </span>
                  </a>
                  <span data-id="element-14">working in Product for over 6 years in B2B SaaS.</span>
                </div>

                <p className="flex flex-wrap items-center gap-2 mt-5 sm:mt-7" data-id="element-15">
                  <span data-id="element-16">I am also working on</span>
                  <span className="flex items-center ml-2" data-id="element-17">
                    <a href="https://two83.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 cursor-pointer transition-all duration-300 shadow-[0_4px_12px_-2px_rgba(31,36,46,0.15)] relative ml-0 flex h-12 w-12 items-center justify-center z-[3] rounded-xl hover:scale-110 group" data-id="element-18">
                      <div className="flex h-12 w-12 items-center justify-center overflow-hidden bg-white shadow-sm border border-stone-200/20 rounded-xl" data-id="element-19">
                        <img src="https://cdn.magicpatterns.com/uploads/5ijFbNeFqjH31pMAdwWWbo/83_(3).svg" alt="Two83" className="h-7 w-7 object-contain" data-id="element-20" />
                      </div>
                      <span className="pointer-events-none absolute -top-12 left-6 z-50 whitespace-nowrap bg-stone-50 text-[10px] font-semibold tracking-wide text-gray-900 opacity-0 shadow-sm transition-all duration-300 border border-stone-200 rounded-[10px] px-2.5 py-1 group-hover:opacity-100 group-hover:-translate-y-2" data-id="element-21">
                        Crafting software that doesn't suck
                      </span>
                    </a>
                    <a href="https://cheltenham.io" target="_blank" rel="noopener noreferrer" className="text-gray-600 cursor-pointer transition-all duration-300 shadow-[0_4px_12px_-2px_rgba(31,36,46,0.15)] relative -ml-3 flex h-12 w-12 items-center justify-center z-[2] rounded-xl hover:scale-110 group" data-id="element-22">
                      <div className="flex h-12 w-12 items-center justify-center overflow-hidden bg-white shadow-sm border border-stone-200/20 rounded-xl" data-id="element-23">
                        <img src="https://cdn.magicpatterns.com/uploads/fDPm3rxc4btmabfCLSyqf9/Cheltenham.io_(2).svg" alt="Cheltenham.io" className="h-7 w-7 object-contain" data-id="element-24" />
                      </div>
                      <span className="pointer-events-none absolute -top-12 left-6 z-50 whitespace-nowrap bg-stone-50 text-[10px] font-semibold tracking-wide text-gray-900 opacity-0 shadow-sm transition-all duration-300 border border-stone-200 rounded-[10px] px-2.5 py-1 group-hover:opacity-100 group-hover:-translate-y-2" data-id="element-25">
                        Training people to use AI
                      </span>
                    </a>
                    <a href="https://writwell.app/" target="_blank" rel="noopener noreferrer" className="text-gray-600 cursor-pointer transition-all duration-300 shadow-[0_4px_12px_-2px_rgba(31,36,46,0.15)] relative -ml-3 flex h-12 w-12 items-center justify-center z-[1] rounded-xl hover:scale-110 group" data-id="element-26">
                      <div className="flex h-12 w-12 items-center justify-center overflow-hidden bg-white shadow-sm border border-stone-200/20 rounded-xl" data-id="element-27">
                        <img src="https://cdn.magicpatterns.com/uploads/dPRBBb9QETZNXrnSZhcDPq/wrtiwell.svg" alt="Writwell" className="h-7 w-7 object-contain" data-id="element-28" />
                      </div>
                      <span className="pointer-events-none absolute -top-12 left-6 z-50 whitespace-nowrap bg-stone-50 text-[10px] font-semibold tracking-wide text-gray-900 opacity-0 shadow-sm transition-all duration-300 border border-stone-200 rounded-[10px] px-2.5 py-1 group-hover:opacity-100 group-hover:-translate-y-2" data-id="element-29">
                        Coming soon...a tool for Solicitors
                      </span>
                    </a>
                  </span>
                </p>

                <p className="flex flex-wrap items-center gap-2 mt-5 sm:mt-7" data-id="element-30">
                  <span data-id="element-31">Ocassionaly share things on</span>
                  <span className="flex items-center ml-2" data-id="element-32">
                    <a href="https://x.com/gordonmcquoid" target="_blank" rel="noopener noreferrer" title="Twitter/X" className="text-gray-600 cursor-pointer transition-all duration-300 shadow-[0_4px_12px_-2px_rgba(31,36,46,0.15)] relative ml-0 flex h-12 w-12 items-center justify-center z-[2] rounded-xl hover:scale-110" data-id="element-33">
                      <div className="flex h-12 w-12 items-center justify-center overflow-hidden bg-white shadow-sm border border-stone-200/20 rounded-xl" data-id="element-34">
                        <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-35">
                          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-36" />
                        </svg>
                      </div>
                    </a>
                    <a href="https://www.linkedin.com/in/gordonmcquoid/" target="_blank" rel="noopener noreferrer" title="LinkedIn" className="text-gray-600 cursor-pointer transition-all duration-300 shadow-[0_4px_12px_-2px_rgba(31,36,46,0.15)] relative -ml-3 flex h-12 w-12 items-center justify-center z-[1] rounded-xl hover:scale-110" data-id="element-37">
                      <div className="flex h-12 w-12 items-center justify-center overflow-hidden bg-white shadow-sm border border-stone-200/20 rounded-xl" data-id="element-38">
                        <Linkedin className="h-5 w-5 text-[#0a66c2]" data-id="element-39" />
                      </div>
                    </a>
                  </span>
                </p>
              </div>

              {/* Sidebar */}
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="mt-10" data-id="element-40">
          <div className="mb-6 flex flex-col sm:flex-row sm:justify-between gap-3 sm:gap-4 sm:items-center" data-id="element-41">
            <h2 className="text-lg sm:text-xl font-medium flex items-center gap-2 leading-7" data-id="element-42">
              <span className="text-lg sm:text-xl leading-7" data-id="element-43">💡</span>
              Content that inspired me
            </h2>
            <div className="flex flex-wrap items-center gap-2 sm:gap-3" data-id="element-44">
              <div ref={categoryRef} className="relative" data-id="element-45">
                <button type="button" onClick={() => {
                setCategoryOpen(!categoryOpen);
                setTagOpen(false);
              }} className={`text-xs font-normal leading-4 text-gray-900 bg-stone-50 flex h-9 w-[130px] sm:w-[140px] items-center justify-between border rounded-[10px] px-3 py-2 transition-colors ${selectedCategory !== 'All Categories' ? 'border-gray-400 bg-white' : 'border-stone-200'}`} data-id="element-46">
                  <span className="overflow-hidden line-clamp-1 pointer-events-none" data-id="element-47">
                    {selectedCategory}
                  </span>
                  <ChevronDown className={`h-4 w-4 opacity-50 transition-transform duration-200 ${categoryOpen ? 'rotate-180' : ''}`} data-id="element-48" />
                </button>
                {categoryOpen && <div className="absolute top-full left-0 mt-1 w-[160px] bg-white border border-stone-200 rounded-[10px] shadow-lg z-50 py-1 overflow-hidden" data-id="element-49">
                    {categories.map(cat => <button key={cat} onClick={() => {
                  setSelectedCategory(cat);
                  setCategoryOpen(false);
                  setShowAll(false);
                }} className={`w-full text-left text-xs leading-4 px-3 py-2 transition-colors hover:bg-stone-50 ${selectedCategory === cat ? 'font-semibold text-gray-900 bg-stone-50' : 'font-normal text-gray-600'}`} data-id="element-50">
                        {cat}
                      </button>)}
                  </div>}
              </div>
              <div ref={tagRef} className="relative" data-id="element-51">
                <button type="button" onClick={() => {
                setTagOpen(!tagOpen);
                setCategoryOpen(false);
              }} className={`text-xs font-normal leading-4 text-gray-900 bg-stone-50 flex h-9 w-[130px] sm:w-[140px] items-center justify-between border rounded-[10px] px-3 py-2 transition-colors ${selectedTag !== 'All Tags' ? 'border-gray-400 bg-white' : 'border-stone-200'}`} data-id="element-52">
                  <span className="overflow-hidden line-clamp-1 pointer-events-none" data-id="element-53">
                    {selectedTag}
                  </span>
                  <ChevronDown className={`h-4 w-4 opacity-50 transition-transform duration-200 ${tagOpen ? 'rotate-180' : ''}`} data-id="element-54" />
                </button>
                {tagOpen && <div className="absolute top-full left-0 mt-1 w-[140px] bg-white border border-stone-200 rounded-[10px] shadow-lg z-50 py-1 overflow-hidden" data-id="element-55">
                    {tags.map(tag => <button key={tag} onClick={() => {
                  setSelectedTag(tag);
                  setTagOpen(false);
                  setShowAll(false);
                }} className={`w-full text-left text-xs leading-4 px-3 py-2 transition-colors hover:bg-stone-50 ${selectedTag === tag ? 'font-semibold text-gray-900 bg-stone-50' : 'font-normal text-gray-600'}`} data-id="element-56">
                        {tag}
                      </button>)}
                  </div>}
              </div>
              <button className="text-xs font-normal leading-4 text-gray-900 bg-stone-50 flex h-9 items-center gap-2 whitespace-nowrap transition-colors duration-150 border border-stone-200 rounded-[10px] px-3 hover:bg-stone-100" data-id="element-57">
                <span data-id="element-58">Sort by Rating</span>
                <ArrowUpDown className="h-3 w-3 transition-transform duration-150" data-id="element-59" />
              </button>
            </div>
          </div>

          <div className="overflow-hidden bg-white/50 backdrop-blur border border-stone-200/50 rounded-xl" data-id="element-60">
            <div className="overflow-x-auto" data-id="element-61">
              <table className="w-full text-left text-sm leading-5" data-id="element-62">
                <thead className="bg-stone-100/30 text-xs leading-4 text-gray-600 border-b border-stone-200/50" data-id="element-63">
                  <tr data-id="element-64">
                    <th className="px-3 sm:px-4 py-3" data-id="element-65">Name</th>
                    <th className="px-3 sm:px-4 py-3 hidden sm:table-cell" data-id="element-66">
                      Category
                    </th>
                    <th className="px-3 sm:px-4 py-3 hidden sm:table-cell" data-id="element-67">
                      Tags
                    </th>
                    <th className="px-3 sm:px-4 py-3 w-24 sm:w-32" data-id="element-68">Rating</th>
                  </tr>
                </thead>
                <tbody data-id="element-69">
                  {visibleContent.map((item, idx) => {
                  const categoryColors: Record<string, string> = {
                    Product: 'bg-orange-100 text-orange-700',
                    'Self-Development': 'bg-emerald-100 text-emerald-700',
                    Business: 'bg-sky-100 text-sky-700',
                    Biography: 'bg-violet-100 text-violet-700',
                    'Tech & AI': 'bg-indigo-100 text-indigo-700'
                  };
                  const tagColors: Record<string, string> = {
                    Book: 'bg-amber-100 text-amber-700',
                    Youtube: 'bg-red-100 text-red-700',
                    Article: 'bg-blue-100 text-blue-700'
                  };
                  const IconComponent = item.tag === 'Book' ? BookOpenIcon : item.tag === 'Youtube' ? PlayCircleIcon : NewspaperIcon;
                  const displayName = item.author ? `${item.name} — ${item.author}` : item.name;
                  return <tr key={idx} className={`transition-colors duration-150 hover:bg-stone-50/50 ${idx > 0 ? 'border-t border-stone-200/30' : ''}`} data-id="element-70">
                        <td className="px-3 sm:px-4 py-2.5 font-medium" data-id="element-71">
                          {item.href ? <a href={item.href} target="_blank" rel="noopener noreferrer" className="text-gray-900 flex items-center gap-2 underline-offset-4 hover:underline" data-id="element-72">
                              <IconComponent className="h-4 w-4 flex-shrink-0 text-gray-600/70" data-id="element-73" />
                              <span className="max-w-[180px] sm:max-w-[320px] overflow-hidden text-ellipsis whitespace-nowrap" data-id="element-74">
                                {displayName}
                              </span>
                            </a> : <span className="text-gray-900 flex items-center gap-2" data-id="element-75">
                              <IconComponent className="h-4 w-4 flex-shrink-0 text-gray-600/70" data-id="element-76" />
                              <span className="max-w-[180px] sm:max-w-[320px] overflow-hidden text-ellipsis whitespace-nowrap" data-id="element-77">
                                {displayName}
                              </span>
                            </span>}
                        </td>
                        <td className="px-3 sm:px-4 py-2.5 hidden sm:table-cell" data-id="element-78">
                          <span className={`whitespace-nowrap text-xs leading-4 font-medium rounded-[10px] px-2 py-0.5 ${categoryColors[item.category] || 'bg-gray-100 text-gray-700'}`} data-id="element-79">
                            {item.category}
                          </span>
                        </td>
                        <td className="px-3 sm:px-4 py-2.5 hidden sm:table-cell" data-id="element-80">
                          <span className={`whitespace-nowrap text-xs leading-4 font-medium rounded-[10px] px-2 py-0.5 ${tagColors[item.tag] || 'bg-gray-100 text-gray-700'}`} data-id="element-81">
                            {item.tag}
                          </span>
                        </td>
                        <td className="px-3 sm:px-4 py-2.5" data-id="element-82">
                          <div title="5 stars" className="flex items-center gap-0.5" data-id="element-83">
                            {[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" data-id="element-84" />)}
                          </div>
                        </td>
                      </tr>;
                })}
                </tbody>
              </table>
            </div>
            {!showAll && hiddenCount > 0 && <button onClick={() => setShowAll(true)} className="flex w-full cursor-pointer items-center justify-center gap-2 pt-3 pb-3 text-sm leading-5 text-gray-600 transition-colors duration-150 border-t border-stone-200/50 hover:bg-stone-50/50" data-id="element-85">
                Load more ({hiddenCount} hidden){' '}
                <ChevronDown className="h-4 w-4" data-id="element-86" />
              </button>}
            {showAll && <button onClick={() => setShowAll(false)} className="flex w-full cursor-pointer items-center justify-center gap-2 pt-3 pb-3 text-sm leading-5 text-gray-600 transition-colors duration-150 border-t border-stone-200/50 hover:bg-stone-50/50" data-id="element-87">
                Show less{' '}
                <ChevronDown className="h-4 w-4 rotate-180 transition-transform" data-id="element-88" />
              </button>}
          </div>
        </section>

        {/* People Section */}
        <section className="mt-12 animate-fade-in-up [animation-delay:0.4s]" data-id="element-89">
          <h2 className="text-lg font-semibold leading-7 text-gray-900" data-id="element-90">
            People Who Inspire Me
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6 mb-0" data-id="element-91">
            {[{
            href: 'https://www.svpg.com/team/marty-cagan/',
            name: 'Marty Cagan',
            initials: 'MC',
            color: 'bg-orange-500',
            img: '',
            desc: 'Founder and Partner at Silicon Valley Product Group (SVPG), built product at Hewlett-Packard, Netscape Communications, and eBay.'
          }, {
            href: 'https://www.lennysnewsletter.com/',
            name: 'Lenny Rachitsky',
            initials: 'LR',
            color: 'bg-blue-500',
            img: '',
            desc: 'Product, growth, and the mastermind behind the #1 product newsletter.'
          }, {
            href: 'https://iteration.design/',
            name: 'Josh Puckett',
            initials: 'JP',
            color: 'bg-violet-500',
            img: '',
            desc: 'Co-founder of Iteration, Previously Design Lead at Dropbox and Principal Designer at Wealthfront.'
          }, {
            href: 'https://kolisifoundation.org/',
            name: 'Siya Kolisi',
            initials: 'SK',
            color: 'bg-emerald-600',
            img: '',
            desc: 'South African Springbok Rugby Captain, two time Rugby World Cup winner.'
          }, {
            href: 'https://kolisifoundation.org/',
            name: 'Rassie Erasmus',
            initials: 'RE',
            color: 'bg-green-700',
            img: '',
            desc: 'South African Springbok Rugby Coach, former Springbok, previously coached at Cheetahs, Western Province and Munster.'
          }, {
            href: 'https://x.com/danshipper?s=20',
            name: 'Dan Shipper',
            initials: 'DS',
            color: 'bg-sky-500',
            img: '',
            desc: 'CEO of Every, writing Chain of Thought on AI and the future of work.'
          }, {
            href: 'https://www.aakashg.com/',
            name: 'Aakash Gupta',
            initials: 'AG',
            color: 'bg-amber-500',
            img: '',
            desc: 'Founder of The Growth Podcast, Previously VP of Product at Apolli.io.'
          }, {
            href: 'https://world.hey.com/jason',
            name: 'Jason Fried',
            initials: 'JF',
            color: 'bg-rose-500',
            img: '',
            desc: 'Co-Founder of 37signals, makers of Basecamp and Hey.'
          }].map((person, idx) => <a key={idx} href={person.href} target="_blank" rel="noopener noreferrer" className="text-gray-900 flex cursor-pointer flex-col gap-4 bg-white/30 backdrop-blur transition-all duration-500 border border-stone-200/40 rounded-2xl p-5 hover:shadow-lg hover:border-stone-300/60" data-id="element-92">
                <div className="flex items-center gap-4" data-id="element-93">
                  <div className="h-14 w-14 flex-shrink-0 overflow-hidden shadow-sm transition-transform duration-500 border border-stone-200/50 rounded-2xl hover:scale-105" data-id="element-94">
                    {person.img ? <img src={person.img} alt={person.name} className="h-[54px] w-[54px] object-cover" data-id="element-95" /> : <div className={`h-[54px] w-[54px] flex items-center justify-center ${person.color} text-white text-lg font-bold`} data-id="element-96">
                        {person.initials}
                      </div>}
                  </div>
                  <div className="min-w-0" data-id="element-97">
                    <p className="text-sm leading-[17.5px] font-bold text-gray-900 transition-colors duration-300" data-id="element-98">
                      {person.name}
                    </p>
                  </div>
                </div>
                <p className="text-xs leading-[19.5px] text-gray-600 m-0" data-id="element-99">
                  {person.desc}
                </p>
              </a>)}
          </div>
        </section>

        {/* Things I Like Section */}
        <section className="mt-12 animate-fade-in-up [animation-delay:0.5s]" data-id="element-100">
          <h2 className="text-lg font-semibold leading-7 text-gray-900" data-id="element-101">
            Things I Like 🛠️
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6 mb-0" data-id="element-102">
            {[{
            name: 'Interface Craft',
            initials: 'IC',
            color: 'bg-violet-500',
            href: 'https://www.interfacecraft.dev/',
            desc: 'A design and interface craft resource by Josh Puckett that helps designers build better digital products through thoughtful interaction patterns and design systems.'
          }, {
            name: 'Wispr Flow',
            initials: 'WF',
            color: 'bg-sky-500',
            href: 'https://wisprflow.ai/',
            desc: 'An AI voice-to-text tool that lets you write, code, and communicate by speaking naturally instead of typing.'
          }, {
            name: 'Excalidraw',
            initials: 'Ex',
            color: 'bg-indigo-500',
            href: 'https://excalidraw.com/',
            desc: 'A simple collaborative whiteboard for sketching diagrams and ideas with a hand-drawn feel.'
          }, {
            name: 'Claude',
            initials: 'Cl',
            color: 'bg-amber-600',
            href: 'https://claude.ai/',
            desc: 'An advanced AI assistant from Anthropic designed to help with writing, reasoning, coding, and complex problem-solving.'
          }, {
            name: 'Cursor',
            initials: 'Cu',
            color: 'bg-gray-800',
            href: 'https://cursor.sh/',
            desc: 'An AI-powered code editor that lets you build software faster by chatting with your code and generating changes with natural language.'
          }, {
            name: 'Obsidian',
            initials: 'Ob',
            color: 'bg-purple-700',
            href: 'https://obsidian.md/',
            desc: 'A powerful knowledge management and note-taking app that turns your notes into a connected personal knowledge graph.'
          }, {
            name: 'Snagit',
            initials: 'Sn',
            color: 'bg-emerald-500',
            href: 'https://www.techsmith.com/snagit/',
            desc: 'A screen capture and recording tool for quickly creating annotated screenshots, tutorials, and visual documentation.'
          }, {
            name: 'Magic Patterns',
            initials: 'MP',
            color: 'bg-rose-500',
            href: 'https://www.magicpatterns.com/',
            desc: 'An AI prototyping tool that turns product ideas or prompts into interactive UI designs and code-ready components.'
          }].map((tool, idx) => <a key={idx} href={tool.href} target="_blank" rel="noopener noreferrer" className="text-gray-900 flex cursor-pointer flex-col gap-4 bg-white/30 backdrop-blur transition-all duration-500 border border-stone-200/40 rounded-2xl p-5 hover:shadow-lg hover:border-stone-300/60" data-id="element-103">
                <div className="flex items-center gap-4" data-id="element-104">
                  <div className="h-14 w-14 flex-shrink-0 overflow-hidden shadow-sm transition-transform duration-500 border border-stone-200/50 rounded-2xl hover:scale-105" data-id="element-105">
                    <div className={`h-[54px] w-[54px] flex items-center justify-center ${tool.color} text-white text-lg font-bold`} data-id="element-106">
                      {tool.initials}
                    </div>
                  </div>
                  <div className="min-w-0 flex items-center gap-1.5" data-id="element-107">
                    <p className="text-sm leading-[17.5px] font-bold text-gray-900 transition-colors duration-300" data-id="element-108">
                      {tool.name}
                    </p>
                    <ExternalLinkIcon className="h-3 w-3 text-gray-400 flex-shrink-0" data-id="element-109" />
                  </div>
                </div>
                <p className="text-xs leading-[19.5px] text-gray-600 m-0" data-id="element-110">
                  {tool.desc}
                </p>
              </a>)}
          </div>
        </section>

        {/* Footer */}
        <footer className="mt-12 pb-8 sm:pb-12 pt-8 border-t border-stone-200/30" data-id="element-111">
          <div className="flex items-center justify-between gap-4 text-sm leading-5 text-gray-600" data-id="element-112">
            <p className="m-0" data-id="element-113">© 2026 Gordon McQuoid</p>
            <div className="flex items-center gap-4" data-id="element-114"></div>
          </div>
        </footer>
      </div>
    </main>;
}